/* MiniAnglers product page — engraving with two options.
   Standard = no engraving (plain piece, no line-item property); Custom (paid)
   lets the customer type a name. When "custom" is chosen AND a linked
   engraving product exists (data-eng-variant), submitting adds a SECOND cart
   line for that product via the Ajax Cart API so it is charged; otherwise the
   form submits normally (single item). */
(function () {
  const t = (k) => (typeof window.maT === 'function' ? window.maT(k) : k);

  function init(root) {
    const form   = root.closest('form');
    const input  = root.querySelector('[data-eng-input]');
    const etch   = root.querySelector('[data-eng-etch]');
    const count  = root.querySelector('[data-eng-count]');
    const preview = root.querySelector('[data-eng-preview]');
    const opts   = root.querySelectorAll('.eng-opt');
    const radios = root.querySelectorAll('input[name="eng_choice"]');
    const maxLen = parseInt(root.dataset.max, 10) || (input ? parseInt(input.getAttribute('maxlength'), 10) : 16) || 16;
    const engVariantId = root.dataset.engVariant ? parseInt(root.dataset.engVariant, 10) : null;
    const cartUrl = root.dataset.cartUrl || '/cart';

    function choice() {
      const c = root.querySelector('input[name="eng_choice"]:checked');
      return c ? c.value : 'standard';
    }

    function render() {
      const custom = choice() === 'custom';
      const name = (input && input.value || '').trim();
      // preview plate: the typed name (only shown for custom)
      if (etch) etch.textContent = custom ? (name ? name.toUpperCase() : t('config.namehere')) : '';
      if (count) count.textContent = `${(input ? input.value.length : 0)}/${maxLen} ${t('config.chars')}`;
    }

    function applyChoice() {
      const custom = choice() === 'custom';
      // the "Gravare" property only submits for custom; show/hide the text field + preview
      if (input)   { input.disabled = !custom; input.hidden = !custom; }
      if (count)   { count.hidden = !custom; }
      if (preview) { preview.hidden = !custom; }
      opts.forEach((o) => o.classList.toggle('is-active', o.dataset.engOpt === (custom ? 'custom' : 'standard')));
      if (custom && input) input.focus();
      render();
    }

    radios.forEach((r) => r.addEventListener('change', applyChoice));
    if (input) input.addEventListener('input', render);
    document.addEventListener('ma:lang', render);
    applyChoice();

    if (!form) return;

    function showToast() {
      const old = document.querySelector('.ma-toast');
      if (old) old.remove();
      const toast = document.createElement('div');
      toast.className = 'ma-toast';
      const msg = document.createElement('span');
      msg.className = 'ma-toast-msg';
      msg.textContent = t('cart.added');
      const link = document.createElement('a');
      link.className = 'ma-toast-link';
      link.href = cartUrl;
      link.textContent = t('cart.view');
      toast.append(msg, link);
      document.body.appendChild(toast);
      requestAnimationFrame(() => toast.classList.add('in'));
      setTimeout(() => { toast.classList.remove('in'); setTimeout(() => toast.remove(), 300); }, 4200);
    }

    // Add to cart via Ajax so we can confirm in place instead of jumping to /cart.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const custom = choice() === 'custom';
      const name = (input && input.value || '').trim();
      const idField = form.querySelector('input[name="id"]');
      const mainId = idField ? parseInt(idField.value, 10) : null;
      const submitBtn = form.querySelector('.product-add');
      const nativeSubmit = () => { if (submitBtn) submitBtn.disabled = false; HTMLFormElement.prototype.submit.call(form); };
      if (!mainId) { nativeSubmit(); return; }

      let items;
      if (custom && name) {
        items = [{ id: mainId, quantity: 1, properties: { Gravare: name } }];
        if (engVariantId) items.push({ id: engVariantId, quantity: 1, properties: { 'Pentru': name } });
      } else {
        items = [{ id: mainId, quantity: 1 }];
      }

      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then((res) => { if (!res.ok) throw new Error('cart add failed'); return res.json(); })
        .then(() => fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json()))
        .then((cart) => {
          const countEl = document.getElementById('cartCount');
          if (countEl) countEl.textContent = cart.item_count;
          if (submitBtn) submitBtn.disabled = false;
          showToast();
        })
        .catch(nativeSubmit); // any failure -> normal add so a sale is never lost
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-engrave]').forEach(init);
  });
})();

/* Product gallery — clicking a thumbnail swaps the main image. */
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    const mainImg = gallery.querySelector('[data-main-image]');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const full = btn.dataset.full;
        if (!full) return;
        mainImg.src = full;
        thumbs.forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });

    window.maSetActiveThumb = function (src) {
      if (!src) return;
      thumbs.forEach((b) => b.classList.toggle('is-active', b.dataset.full === src));
    };
  });
})();

/* Variant picker — swaps hidden id, price, and featured image when a
   color swatch is clicked or a non-color option dropdown changes. */
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const dataEl = document.querySelector('[data-product-json]');
    const form = document.querySelector('.product-info form');
    if (!dataEl || !form) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.options) return;

    const hiddenId = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('.product-price');
    const wasEl = document.querySelector('[data-compare]');
    const pctEl = document.querySelector('[data-sale-pct]');
    const mediaImg = document.querySelector('[data-main-image]');
    const addBtn = form.querySelector('.product-add');
    if (!hiddenId) return;

    const selected = {};
    data.options.forEach((name) => {
      const sel = form.querySelector(`select[name="options[${name}]"]`);
      const active = form.querySelector(`.swatch.is-active[data-option-name="${name}"]`);
      if (active) selected[name] = active.dataset.value;
      else if (sel) selected[name] = sel.value;
    });

    function formatMoney(cents) {
      const fmt = data.money_format || '{{amount}}';
      const intPart = Math.floor(cents / 100);
      const decPart = String(cents % 100).padStart(2, '0');
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intPart.toLocaleString('ro-RO'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${intPart.toLocaleString('ro-RO')},${decPart}`)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(intPart))
        .replace(/\{\{\s*amount\s*\}\}/g, `${intPart}.${decPart}`);
    }

    function findVariant() {
      return data.variants.find((v) =>
        data.options.every((name, idx) => v.options[idx] === selected[name])
      );
    }

    function update() {
      const variant = findVariant();
      if (!variant) return;
      hiddenId.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      // sale: Compare-at price above the price -> old price crossed out + -X%
      const onSale = variant.compare_at_price > variant.price;
      if (wasEl) {
        wasEl.hidden = !onSale;
        wasEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (pctEl) {
        pctEl.hidden = !onSale;
        if (onSale) pctEl.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
      if (mediaImg && variant.featured_image) {
        mediaImg.src = variant.featured_image;
        if (typeof window.maSetActiveThumb === 'function') window.maSetActiveThumb(variant.featured_image);
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
      }
    }

    form.querySelectorAll('.swatch').forEach((btn) => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.optionName;
        const val = btn.dataset.value;
        if (!optName) return;
        selected[optName] = val;
        form.querySelectorAll(`.swatch[data-option-name="${optName}"]`).forEach((b) => {
          const isMe = b === btn;
          b.classList.toggle('is-active', isMe);
          b.setAttribute('aria-checked', isMe ? 'true' : 'false');
        });
        update();
      });
    });

    form.querySelectorAll('select[name^="options["]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const m = sel.name.match(/^options\[(.+)\]$/);
        if (!m) return;
        selected[m[1]] = sel.value;
        update();
      });
    });
  });

  // Turns a plain "Label: Value" bullet list typed into the product
  // description into aligned spec rows, reusing the same .spec component
  // the homepage product cards already use — so merchants can add specs
  // by typing a bulleted list in Shopify's description field, no metafields.
  function enhanceSpecList() {
    document.querySelectorAll('.product-desc ul').forEach((ul) => {
      ul.classList.add('spec');
      ul.querySelectorAll('li').forEach((li) => {
        const text = li.textContent;
        const i = text.indexOf(':');
        if (i === -1) return;
        const k = document.createElement('span');
        k.className = 'k';
        k.textContent = text.slice(0, i).trim();
        const v = document.createElement('span');
        v.className = 'val';
        v.textContent = text.slice(i + 1).trim();
        li.textContent = '';
        li.append(k, v);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', enhanceSpecList);
})();

/* Sticky add-to-cart bar (mobile): appears once the main button scrolls out of view. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const bar = document.querySelector('[data-pdp-sticky]');
    const form = document.querySelector('.product-info form');
    if (!bar || !form) return;
    const mainBtn = form.querySelector('.product-add');
    const stickyBtn = bar.querySelector('[data-sticky-add]');
    const stickyPrice = bar.querySelector('[data-sticky-price]');
    const priceEl = document.querySelector('.product-price');

    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainBtn || undefined);
      else HTMLFormElement.prototype.submit.call(form);
    });

    function sync() {
      if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
      if (stickyBtn && mainBtn) stickyBtn.disabled = mainBtn.disabled;
    }
    if (window.MutationObserver) {
      const mo = new MutationObserver(sync);
      if (priceEl) mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
      if (mainBtn) mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
    sync();

    if (window.IntersectionObserver && mainBtn) {
      let mainVisible = true, footerVisible = false;
      const decide = function () { bar.classList.toggle('show', !mainVisible && !footerVisible); };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { mainVisible = en.isIntersecting; });
        decide();
      }, { rootMargin: '0px 0px -24px 0px' }).observe(mainBtn);
      const footer = document.querySelector('.footer');
      if (footer) new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { footerVisible = en.isIntersecting; });
        decide();
      }).observe(footer);
      decide();
    } else {
      bar.classList.add('show');
    }
  });
})();
